import { render, staticRenderFns } from "./rewardTwoPlusGiftEdit.vue?vue&type=template&id=2284a3ba&scoped=true&"
import script from "./rewardTwoPlusGiftEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTwoPlusGiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284a3ba",
  null
  
)

export default component.exports